import { ampli } from '@/ampli';
import type { CommonData } from '@/app/common/createCommonData.ts';
import { getABTests, getUUID } from '@/app/common/amplitude/events/ampliEventsUtils.ts';
import type { SearchInfoData } from '@/app/search/types.ts';
import { createOffsetFromPage, createPageFromOffset } from '@/app/components/search/utils/pagerUtils.ts';
import type { DealCard } from '@/app/components/search/utils/buildDealCards/dealCardTypes.ts';
import { URLParameters } from '@/app/common/urlParameters.ts';
import type { SearchParams } from '@/server/searchParams.ts';
import { RESULT_VIEW } from '@/app/common/tracking/trackingTypes.ts';
import { canUseAmplitude } from '@/app/common/amplitude/amplitudeUtils.ts';
import type { Localization } from '@/app/components/search/common/Localization';

type AmpliResultShownProps = {
  searchParams: SearchParams;
  searchInfoData: SearchInfoData;
  dealCards?: DealCard[];
  listView: boolean | null;
  commonData: CommonData;
  localization: Localization;
};

export const ampliResultShown = ({
  searchParams,
  searchInfoData,
  dealCards,
  listView,
  commonData,
  localization,
}: AmpliResultShownProps) => {
  if (!canUseAmplitude(commonData, localization)) return;

  const { searchId, searchType } = searchInfoData;
  const { abTests } = commonData;

  const offset = createOffsetFromPage(searchParams[URLParameters.PAGE]);
  const pageId = createPageFromOffset(offset);
  const results = Array.isArray(dealCards) ? dealCards : [];
  const resultQty = results.length;
  const alternativeaccommodationQty = results.filter(
    (dealCard) => dealCard.product?.accommodation?.isAlternative
  ).length;
  const resultView = listView ? RESULT_VIEW.LIST : RESULT_VIEW.MAP;
  const uuid = getUUID(commonData);

  ampli.resultShown({
    ...getABTests(abTests),
    'alternative accommodation qty': alternativeaccommodationQty,
    'features enabled': [], // TODO: Implement in a future iteration
    'page id': pageId,
    'result qty': resultQty,
    'result view': resultView,
    'search id': searchId,
    'search type': searchType,
    uuid,
  });
};
